export default __webpack_public_path__ + "static/media/logo.397233b1.png";